import React, { JSX, useCallback } from "react";
import { ToastManager } from "utilities/toast/toast-manager";
import "./user-login-page.scss";
import { LogInButton } from "components/log-in-button/log-in-button";
import { t } from "utilities/localization/t";
import { CreateAccountAnchor } from "components/create-account-anchor/create-account-anchor";
import { Heading, HeadingPriority, HeadingSize } from "components/typography/heading/heading";
import { Paragraph, ParagraphStyle } from "components/typography/paragraph/paragraph";
// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface UserLoginPageProps {}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME: string = "user-login-page";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const UserLoginPage: React.FC<UserLoginPageProps> = (): JSX.Element => {
    const onError = useCallback(({ message }: Error) => {
        ToastManager.error(message);
    }, []);
    return (
        <div className={CSS_CLASS_NAME}>
            <>
                <Paragraph style={ParagraphStyle.Label}>{t("nfpaLearningPortal")}</Paragraph>
                <Heading size={HeadingSize.Default} priority={HeadingPriority.H1}>
                    {t("advanceYourCareerWithTraining")}
                </Heading>
                <div className={`${CSS_CLASS_NAME}__actions`}>
                    <LogInButton cssClassName={`${CSS_CLASS_NAME}__button`} /> {t("or")}{" "}
                    <CreateAccountAnchor cssClassName={`${CSS_CLASS_NAME}__anchor`} />
                </div>
            </>
        </div>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { UserLoginPage };

// #endregion Exports
